import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import Connexion from './Connexion';
import Accueil from './Accueil';
import Parametres from './Parametres';
import Profile from './Profile';
import Leaderboard from './Leaderboard';
import { DisplayNameProvider } from './DisplayNameContext';
import { EventProvider } from './EventContext';
import CreerCompte from './CreerCompte';
import Suggestion from './Suggestion';
import Survey from './Survey';

function App() {
  return (
    <DisplayNameProvider>
      <EventProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="/Connexion" element={<Connexion />} />
              <Route path="/Accueil" element={<Accueil />} />
              <Route path="/Parametres" element={<Parametres />} />
              <Route path="/Profile" element={<Profile />} />
              <Route path="/Leaderboard" element={<Leaderboard />} />
              <Route path="/CreerCompte" element={<CreerCompte />} />
              <Route path="/Suggestion" element={<Suggestion />} />
              <Route path="/survey/:QuizInstanceId" element={<Survey />} />
            </Routes>
          </div>
        </Router>
      </EventProvider>
    </DisplayNameProvider>
  );
}

function MainPage() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/Connexion');
  };

  return (
    <div className="Frame51">
      {/* Assurez-vous que les classes CSS utilisées sont définies dans App.css */}
      <div className="Rectangle56"></div>
      <div className="Rectangle700"></div>
      <div className="Rectangle83"></div>
      <div className="Rectangle0"></div>
      <div className="Rectangle115"></div>
      <div className="Rectangle68"></div>
      <div className="Rectangle69"></div>
      <div className="Rectangle67"></div>
      <div className="Rectangle66"></div>
      <div className="Rectangle73"></div>
      <div className="Rectangle84"></div>
      <div className="Rectangle60"></div>
      <div className="Rectangle701"></div>
      <div className="Rectangle80"></div>
      <div className="Rectangle78"></div>
      <div className="Rectangle28"></div>
      <div className="Rectangle86"></div>
      <div className="Rectangle29"></div>
      <div className="Button" onClick={handleClick}>
        <span>Commencer</span>
      </div>
      <div className="Int">.Int</div>
      <div className="Credits"></div>
      <div className="Rectangle8"></div>
      <div className="Image2"></div>
      <div className="Image3"></div>
    </div>
  );
}

export default App;
